import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { useSelectFormField } from '../../Select/hooks/useSelectFormField.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useLegacySelectFormField = function useLegacySelectFormField(props) {
  var selectTriggerProps = props.selectTriggerProps;
  var _useSelectFormField = useSelectFormField(props),
    rootProps = _useSelectFormField.rootProps,
    selectProps = _useSelectFormField.selectProps,
    selectPopoverProps = _useSelectFormField.selectPopoverProps,
    controlContainerProps = _useSelectFormField.controlContainerProps,
    validationMessageProps = _useSelectFormField.validationMessageProps,
    utilityProps = _useSelectFormField.utilityProps,
    selectValue = _useSelectFormField.selectValue;
  return {
    rootProps: rootProps,
    selectProps: selectProps,
    selectPopoverProps: _objectSpread(_objectSpread({}, selectPopoverProps), {}, {
      crossOffset: false
    }),
    selectTriggerProps: _objectSpread(_objectSpread({}, selectTriggerProps), {}, {
      containerRef: controlContainerProps.ref
    }),
    validationMessageProps: validationMessageProps,
    utilityProps: utilityProps,
    selectValue: selectValue
  };
};

export { useLegacySelectFormField };
//# sourceMappingURL=useLegacySelectFormField.js.map
